import React, { useContext } from "react";
import { Heading, TextField, Select } from "@foris/avocado-suite";
import { BookingContext } from "../../context/BookingContext";
import { Types } from "../../context/request.reducer";
import { useTranslation } from "react-i18next";
import UserSelect from "../AsyncSelectors/UserAsyncSelect";
import Textarea from "@common/components/Textarea";
import css from "./requestForm.module.scss";
import useBookingAccess from "@common/hooks/useBookingAccess";

const Form = () => {
  const { isAdminBooking } = useBookingAccess();
  const { state, dispatch } = useContext(BookingContext);
  const { t } = useTranslation();

  return (
    <div className={css.requestForm}>
      <Heading type="h4">{t("booking.booking-request.form.title")}</Heading>

      {isAdminBooking && <UserSelect className={css.requestForm_selector} />}

      <TextField
        placeholder={t("booking.booking-request.form.event-title.placeholder")}
        label={t("booking.booking-request.form.event-title.label")}
        value={state?.request?.title?.value || ""}
        maxLength={25}
        status={state?.request?.title?.error ? "error" : undefined}
        statusText={state?.request?.title?.error ? "El título del evento es requerido" : null}
        className={css.requestForm_field}
        onChange={e =>
          dispatch({ type: Types.SetTitle, payload: { value: e?.target?.value, error: false } })
        }
      />

      <Select
        label={t("booking.booking-request.form.event-type.label")}
        placeholder={t("booking.booking-request.form.event-type.placeholder")}
        options={state?.request?.eventTypesOptions || []}
        error={state?.request?.eventType?.error ? "El tipo de evento es requerido" : null}
        className={css.requestForm_selector}
        maxMenuHeight={150}
        onChange={e =>
          dispatch({ type: Types.SetEventType, payload: { value: e?.value, error: false } })
        }
      />

      <Textarea
        className={css.requestForm_textarea}
        label={t("booking.booking-request.form.description.label")}
        value={state?.request?.description?.value || ""}
        onChange={value =>
          dispatch({
            type: Types.SetDescription,
            payload: { value, error: false },
          })
        }
      />
    </div>
  );
};

export default Form;
